import React, { useRef } from 'react';
import "./jobdescription.css";
import Header from "../common/header/Header";
import Footer from "../home/footer/Footer";
import queryString from "query-string";
import { useEffect, useState } from "react";
import axios from "axios";
import data from "../../configs/uc-default/uc-default.json";
import Config from '../../configs';
import maping from '../../configs/jobDepartments/jobDepartments.json';
import { isMobile } from '../../utils';

const baseUrl = `${Config.gatewayBaseUrl}/api/v2/platform-gateway`;

function JobDescription({ location }) {
  const [job_title, setJobTitle] = useState("");
  const [job_location, setJobLocation] = useState([]);
  const [job_description, setJobDescription] = useState("");
  const [apply_url, setApplyUrl] = useState("");
  const backgroundColor = useRef();
  const topRef = useRef();

  useEffect(() => {
    window.scrollTo(0, 0);
    const { id } = queryString.parse(location.search);
    axios
      .post(`${baseUrl}/getJobDetails`, {
        jobId: id,
      })
      .then((response) => {
        backgroundColor.current = maping.backgroundColors[maping.parentDepartmentInUc__departmentInCareerPage[response.data.jobDetails.parent_department]];
        setJobTitle(response.data.jobDetails.job_title);
        setJobLocation(response.data.jobDetails.location_city);
        setJobDescription(response.data.jobDetails.job_description);
        setApplyUrl(response.data.jobDetails.apply_url);
      });
  }, []);


  const handleObserver = (entities, observer) => {
    const isVisible = entities[0].isIntersecting;
    if (!isVisible) {
      document.querySelector(".uc-navbar-wrapper").classList.add("white-header");
    } else {
      document.querySelector(".uc-navbar-wrapper").classList.remove("white-header");
    }
  }

  const options = {
    rootMargin: "-64px 0px 0px 0px",
    threshold: 0 // Only observe when the entire box is in view
  }
  const observer = new IntersectionObserver(
    handleObserver, //callback
    options
  );

  useEffect(() => {
    // Create an observer
    //Observ the `ref`
    observer.observe(topRef.current);
  }, [])

  var decodeEntities = (function () {
    var element = document.createElement("div");
    // TODO: check logic here
    function decodeHTMLEntities(str) {
      if (str && typeof str === "string") {
        str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, "");
        element.innerHTML = str;
        str = element.innerHTML;
        element.innerHTML = "";
      }
      return str;
    }
    return decodeHTMLEntities;
  })();
  var job_description_enc = decodeEntities(job_description);

  function createMarkup() {
    return { __html: job_description_enc };
  }
  const getHeaderBackgroundColor = () => {
    if (!isMobile()) {
      console.log(backgroundColor.current)
      return backgroundColor.current;
    }
  }
  return (
    <div className="jd">
      <Header backgroundColor={getHeaderBackgroundColor()} />
      <div className="top" ref={topRef} style={{ background: backgroundColor.current }}>
        <div className="content">
          <div className="jobtitle">{job_title}</div>
          <div className="joblocation">
            {job_location.map((location, index) => (
              <span key={index}>
                {index === 0 ? undefined : ", "}
                {location}
              </span>
            ))}
          </div>
        </div>
      </div>
      <div className="jobdetail-wrapper">
        <div className="row jobdetail">
          <div className="col-md-7 col-12 content">
            <div
              className="responsibilities"
              dangerouslySetInnerHTML={createMarkup()}
            />
          </div>

          <div className="col-xl-4 col-md-5 col-12 apply">
            <a href={apply_url} target="blank">
              {" "}
              <button className="button-apply">
                Apply for this position
              </button>{" "}
            </a>
            <div className="uc-default">
              <div className="uc-default-text" dangerouslySetInnerHTML={{__html: data["uc-default"]}} />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default JobDescription;
